export default {
  copyright: '版权所有 © 迅竞科技 \u00a0  北京迅竞科技有限责任公司 \n xunjingtech.com \u00a0 邮箱：info@xungjingtech.com',
  icp: '京ICP备19003830号-1',
  beian: '京公网安备 11010802035158号'
};